<div class="container">
  <ng-template #offerDropdownMenu>
    @if (selectedItem) {
      <div class="menu">
        @if (offerMenuState.canChangeAlternativeWithMainOffer) {
          <button class="bold"
            (click)="changeAlternativeWithMainOffer(selectedItem)">
            <img alt="icon" src="assets/icons/make-main.svg">
            <span fiTranslation="REQUEST_DETAIL_HEADER_MENU_MAIN_OFFER_SWITCH"></span>
          </button>
        }
        @if (offerMenuState.canAddAlternativeToMainOffer) {
          <button class="bold"
            (click)="addAlternativeToMainOffer(selectedItem)">
            <img alt="icon" src="assets/icons/new/arrow-up.svg">
            <span fiTranslation="REQUEST_DETAIL_HEADER_MENU_ADDITIONAL_MAIN_OFFER"></span>
          </button>
        }
        @if (offerMenuState.canMakeOfferToAlternative) {
          <button class="bold"
            (click)="makeOfferToAlternative(selectedItem)">
            <img alt="icon" src="assets/icons/new/arrow-down.svg">
            <span fiTranslation="REQUEST_DETAIL_HEADER_MENU_MAIN_OFFER_TO_ALTERNATIVE"></span>
          </button>
        }
        @if (selectedItem.IsManual) {
          <button
            (click)="editOrderOrOffer(selectedItem, 'offer')">
            <img class="edit" alt="icon" src="assets/icons/pencil.svg">
            <span fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER_EDIT"></span>
          </button>
        }
        @if (selectedItem.IsManual) {
          <button (click)="onDelete(selectedItem)">
            <img alt="icon" src="assets/icons/delete-black.svg">
            <span fiTranslation="REQUEST_DETAIL_HEADER_MENU_DELETE_OFFER"></span>
          </button>
        }
      </div>
    }
  </ng-template>

  <ng-template #orderDropdownMenu>
    @if (selectedItem && selectedItem.IsManual) {
      <div class="menu">
        <button (click)="editOrderOrOffer(selectedItem, 'order')">
          <img class="edit" alt="icon" src="assets/icons/pencil.svg">
          <span fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER_EDIT"></span>
        </button>
        <button (click)="onDelete(selectedItem)">
          <img alt="icon" src="assets/icons/delete-black.svg">
          <span fiTranslation="REQUEST_DETAIL_HEADER_MENU_DELETE_ORDER"></span>
        </button>
      </div>
    }
  </ng-template>

  @if (!composerOffers?.length && !composerOrders?.length) {
    <div class="no-entries-container">
      <div class="title">
        <img src="assets/icons/update.svg" alt="update">
        <span class="title-text" fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER_EXPLAINATION_HEADLINE"></span>
      </div>
      <div class="description" fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER_EXPLAINATION_DESCRIPTION">
      </div>
      <div class="link-container custom" [hasHTMLTags]="true"
      fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER_EXPLAINATION_LINK"></div>
    </div>
  }

  <div class="card offers-card">
    @if (offerActionName && composerOffers?.length) {
      <div class="info-container">
        <div class="title">
          <img src="assets/icons/update.svg" alt="update">
          <span class="title-text" fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFERS_INFO_TEXT_HEADLINE"></span>
        </div>
        <div class="description" [hasHTMLTags]="true"
          fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFERS_INFO_TEXT_DESCRIPTION">
        </div>
      </div>
    }

    <div class="card-title" fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER"></div>

    @if (!composerOffers?.length) {
      <div class="no-items-container">
        <img src="assets/icons/file-pencil.svg" alt="offer">
        <div class="no-item-title" fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER_EMPTY_HEADLINE"></div>
        <div class="no-item-desc" fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER_EMPTY_DESCRIPTION"></div>
      </div>
    }

    @if (composerOffers?.length) {
      <table class="order-table">
        <thead>
          <tr>
            <th fiTranslation="ALT_TEXT_REQUEST_TYPE_OFFER"></th>
            <th fiTranslation="REQUEST_DETAIL_HEADER_MENU_VALUE" class="amount"></th>
            <th fiTranslation="Status" class="status"></th>
            <th class="action"></th>
          </tr>
        </thead>
        <tbody>
          @for (composerOffer of composerOffers; track composerOffer) {
            @if (composerOffer.IsMain) {
              <tr>
                <td>
                  {{ composerOffer.Name }}
                  @if (composerOffer.IsManual) {
                    <img
                      #TOOLTIP2
                      matTooltip="{{TOOLTIP2.dataset.matTooltip}}"
                      matTooltipShowDelay="400"
                      [isTitle]="true"
                      fiTranslation="ALT_TEXT_OFFER_ORDER_EDIT_MANUALLY"
                      matTooltipPosition="below"
                      matTooltipClass='tooltip-style'
                      (click)="editOrderOrOffer(composerOffer,'offer')" class="edit-icon"
                      alt="icon" src="assets/icons/pencil.svg">
                    }
                    @if (!composerOffer.IsManual) {
                      <img
                        #TOOLTIP1
                        matTooltip="{{TOOLTIP1.dataset.matTooltip}}"
                        matTooltipShowDelay="400"
                        [isTitle]="true"
                        fiTranslation="REQUEST_DETAIL_HEADER_MENU_TOOLTIP_COMPOSER_OFFER"
                        matTooltipPosition="below"
                        matTooltipClass='tooltip-style'
                        class="link-icon" alt="icon" src="assets/icons/link-horizontal.svg">
                      }
                    </td>
                    <td class="amount">
                      {{ composerOffer.Amount | appCurrency: composerOffer.CurrencyCode }}
                    </td>
                    <td class="status">
                      @if (offerSubmitExpiredById[composerOffer.Id]) {
                        <span
                        fiTranslation="REQUEST_DETAIL_HEADER_MENU_MAIN_OFFER_STATUS"></span>
                      }
                    </td>
                    <td class="action">
                      @if ((mainOfferCount > 1 || composerOffer.IsManual) && !(composerOffer.IsMain && editedItem?.data === composerOffer)) {
                        <button [class.selected]="selectedItem === composerOffer" class="menu-btn"
                          (click)="toggleSelectedItem(composerOffer)">
                        <img alt="Menu" src="/assets/icons/dots-vertical.svg">
                          <span class="u-hidden-visually" fiTranslation="ALT_TEXT_REQUEST_ADDITIONAL_ACTIONS"></span>
                        </button>
                    }
                    @if ((composerOffer.IsMain && editedItem?.data === composerOffer)) {
                      <img alt="Menu" class="close"
                        (click)="editedItem = null" src="/assets/icons/close-icon.svg">
                      }
                      @if (selectedItem === composerOffer) {
                        <ng-container *ngTemplateOutlet="offerDropdownMenu"></ng-container>
                      }
                    </td>
                  </tr>
                }
                @if (composerOffer.IsMain && editedItem?.data === composerOffer) {
                  <tr>
                    <td class="editor-cell" colspan="4">
                      <fi-offer-editor [showSaveAndPlaceButton]="false" (edited)="onEditFinish($event)"
                      [inputData]="editedItem"></fi-offer-editor>
                    </td>
                  </tr>
                }
              }
              @if (composerOffers.length && hasAlternativeOffers) {
                <tr class="alternative-tr">
                  <td colspan="4" class="alternative" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ALTERNATIVES"></td>
                </tr>
                @for (composerOffer of composerOffers; track composerOffer) {
                  @if (!composerOffer.IsMain) {
                    <tr>
                      <td>
                        {{ composerOffer.Name }}
                        @if (composerOffer.IsManual) {
                          <img
                            #TOOLTIP2
                            matTooltip="{{TOOLTIP2.dataset.matTooltip}}"
                            matTooltipShowDelay="400"
                            [isTitle]="true"
                            fiTranslation="ALT_TEXT_OFFER_ORDER_EDIT_MANUALLY"
                            matTooltipPosition="below"
                            matTooltipClass='tooltip-style'
                            (click)="editOrderOrOffer(composerOffer,'offer')" class="edit-icon"
                            alt="icon" src="assets/icons/pencil.svg">
                          }
                          @if (!composerOffer.IsManual) {
                            <img
                              #TOOLTIP1
                              matTooltip="{{TOOLTIP1.dataset.matTooltip}}"
                              matTooltipShowDelay="400"
                              [isTitle]="true"
                              fiTranslation="REQUEST_DETAIL_HEADER_MENU_TOOLTIP_COMPOSER_OFFER"
                              matTooltipPosition="below"
                              matTooltipClass='tooltip-style'
                              class="link-icon" alt="icon" src="assets/icons/link-horizontal.svg">
                            }
                          </td>
                          <td class="amount">
                            {{ composerOffer.Amount | appCurrency: composerOffer.CurrencyCode }}
                          </td>
                          <td class="status">
                          </td>
                          <td class="action">
                            @if (!(!composerOffer.IsMain && editedItem?.data === composerOffer)) {
                              <button [class.selected]="selectedItem === composerOffer" class="menu-btn"
                                (click)="toggleSelectedItem(composerOffer)">
                              <img alt="Menu" src="/assets/icons/dots-vertical.svg">
                                <span class="u-hidden-visually" fiTranslation="ALT_TEXT_REQUEST_ADDITIONAL_ACTIONS"></span>
                              </button>
                          }
                          @if ((!composerOffer.IsMain && editedItem?.data === composerOffer)) {
                            <img alt="Menu" class="close"
                              (click)="editedItem = null" src="/assets/icons/close-icon.svg">
                            }
                            @if (selectedItem === composerOffer) {
                              <ng-container *ngTemplateOutlet="offerDropdownMenu"></ng-container>
                            }
                          </td>
                        </tr>
                      }
                      @if (!composerOffer.IsMain && editedItem?.data === composerOffer) {
                        <tr>
                          <td class="editor-cell" colspan="4">
                            <fi-offer-editor [showSaveAndPlaceButton]="false" (edited)="onEditFinish($event)"
                            [inputData]="editedItem"></fi-offer-editor>
                          </td>
                        </tr>
                      }
                    }
                  }
                </tbody>
              </table>
            }
            <button class="new-btn" (click)="createOrderOrOffer('offer')"><span
            [fiTranslation]="!editedItem?.data && editedItem?.isOrder === false ? 'REQUEST_DETAIL_HEADER_MENU_REMOVE_OFFER_MANUALLY' : 'REQUEST_DETAIL_HEADER_MENU_ADD_OFFER_MANUALLY'"></span>
            <mat-icon>{{ !editedItem?.data && editedItem?.isOrder === false ? 'remove' : 'add' }}</mat-icon>
          </button>

          @if (!editedItem?.data && editedItem?.isOrder === false) {
            <div class="new-editor">
              <fi-offer-editor [showSaveAndPlaceButton]="false" (edited)="onEditFinish($event)"
              [inputData]="editedItem"></fi-offer-editor>
            </div>
          }
        </div>

        <div class="card orders-card">
          @if (orderActionName && composerOrders?.length && !orderPlaced) {
            <div class="info-container">
              <div class="title">
                <img src="assets/icons/update.svg" alt="update">
                <span class="title-text" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDERS_INFO_TEXT_HEADLINE"></span>
              </div>
              <div class="description" [hasHTMLTags]="true"
                fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDERS_INFO_TEXT_DESCRIPTION">
            </div>
          </div>
        }

        <div class="card-title" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER"></div>

        @if (!composerOrders?.length) {
          <div class="no-items-container">
            <img src="assets/icons/offer2.svg" alt="order">
            <div class="no-item-title" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER_EMPTY_HEADLINE"></div>
            <div class="no-item-desc" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER_EMPTY_DESCRIPTION"></div>
          </div>
        }

        @if (composerOrders?.length) {
          <table class="order-table">
            <thead>
              <tr>
                <th fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER"></th>
                <th fiTranslation="REQUEST_DETAIL_HEADER_MENU_VALUE" class="amount"></th>
                <th fiTranslation="Status" class="status"></th>
                <th class="action"></th>
              </tr>
            </thead>
            <tbody>
              @for (composerOrder of composerOrders; track composerOrder) {
                <tr>
                  <td>
                    {{ composerOrder.Name }}
                    @if (composerOrder.IsManual) {
                      <img
                        #TOOLTIP2
                        matTooltip="{{TOOLTIP2.dataset.matTooltip}}"
                        matTooltipShowDelay="400"
                        [isTitle]="true"
                        fiTranslation="ALT_TEXT_OFFER_ORDER_EDIT_MANUALLY"
                        matTooltipPosition="below"
                        matTooltipClass='tooltip-style'
                        (click)="editOrderOrOffer(composerOrder,'order')" class="edit-icon"
                        alt="icon" src="assets/icons/pencil.svg">
                      }
                      @if (!composerOrder.IsManual) {
                        <img
                          #TOOLTIP1
                          matTooltip="{{TOOLTIP1.dataset.matTooltip}}"
                          matTooltipShowDelay="400"
                          [isTitle]="true"
                          fiTranslation="REQUEST_DETAIL_HEADER_MENU_TOOLTIP_COMPOSER_ORDER"
                          matTooltipPosition="below"
                          matTooltipClass='tooltip-style'
                          class="link-icon" alt="icon" src="assets/icons/link-horizontal.svg">
                        }
                      </td>
                      <td class="amount">
                        {{ composerOrder.Amount | appCurrency: composerOrder.CurrencyCode }}
                      </td>
                      <td class="status">
                        @if (orderPlaced || (!orderActionName && !offerActionName && composerOrders?.length)) {
                          <span
                          fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_ORDER_PLACED"></span>
                        }
                      </td>
                      <td class="action">
                        @if (composerOrder.IsManual && !(editedItem?.data === composerOrder)) {
                          <button [class.selected]="selectedItem === composerOrder" class="menu-btn"
                            (click)="toggleSelectedItem(composerOrder)">
                          <img alt="Menu" src="/assets/icons/dots-vertical.svg">
                            <span class="u-hidden-visually" fiTranslation="ALT_TEXT_REQUEST_ADDITIONAL_ACTIONS"></span>
                          </button>
                      }
                      @if ((editedItem?.data === composerOrder)) {
                        <img alt="Menu" class="close" (click)="editedItem = null"
                          src="/assets/icons/close-icon.svg">
                        }
                        @if (selectedItem === composerOrder) {
                          <ng-container *ngTemplateOutlet="orderDropdownMenu"></ng-container>
                        }
                      </td>
                    </tr>
                    @if (editedItem?.data === composerOrder) {
                      <tr>
                        <td class="editor-cell" colspan="4">
                          <fi-offer-editor [showSaveAndPlaceButton]="false" (edited)="onEditFinish($event)"
                          [inputData]="editedItem"></fi-offer-editor>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            }
            <button (click)="createOrderOrOffer('order')" class="new-btn"><span
            [fiTranslation]="!editedItem?.data && editedItem?.isOrder === true ? 'REQUEST_DETAIL_HEADER_MENU_REMOVE_ORDER_MANUALLY' : 'REQUEST_DETAIL_HEADER_MENU_ADD_ORDER_MANUALLY'"></span>
            <mat-icon>{{ !editedItem?.data && editedItem?.isOrder === true ? 'remove' : 'add' }}</mat-icon>
          </button>

          @if (!editedItem?.data && editedItem?.isOrder === true) {
            <div class="new-editor">
              <fi-offer-editor [showSaveAndPlaceButton]="showSaveAndPlaceButton && composerOffers.length > 0"
                (edited)="onEditFinish($event)"
                (editedWithPlaceOrder)="onEditWithPlaceOrderFinish($event)"
              [inputData]="editedItem"></fi-offer-editor>
            </div>
          }
        </div>
      </div>


      <div #OVERLAY class="overlay" [class.active]="isActive"></div>
